import { observer } from 'mobx-react-lite';
import { UIService } from '~/service/service.ui';
import { useService } from '~/shared/service/service.base';

export const IndexPage = observer(() => {
	const [ui] = useService(UIService);
	ui.usePageTitle('Dashboard');
	return <div>We should think about content on the index page, something like dashboard?</div>;
});
